import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface PriceBreakGroupFieldRemovalDialogProps {
  /** The removed item custom field that quotes combine price list breaks by, or null when closed */
  fieldName: string | null;
  /** Called when the user cancels the save */
  onCancel: () => void;
  /** Called when the user confirms the save */
  onConfirm: () => void;
}

/**
 * Confirms saving item custom fields that remove, rename, or make multi-value
 * the field quotes combine price list breaks by.
 * @param props - PriceBreakGroupFieldRemovalDialogProps
 * @returns Confirmation dialog element
 */
export function PriceBreakGroupFieldRemovalDialog({
  fieldName,
  onCancel,
  onConfirm,
}: PriceBreakGroupFieldRemovalDialogProps) {
  return (
    <AlertDialog
      open={fieldName !== null}
      onOpenChange={(open) => !open && onCancel()}
    >
      <AlertDialogContent className="max-w-[calc(100%-2rem)] sm:max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle>Change {fieldName}?</AlertDialogTitle>
          <AlertDialogDescription>
            Quotes combine price list breaks by {fieldName}. Removing, renaming,
            or making it multi-select makes draft quotes combine by the same
            item only, which can change their prices. Finalized quotes keep
            their prices.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col-reverse sm:flex-row gap-2">
          <AlertDialogCancel className="mt-0">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Save anyway</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
